import { useState, useRef, useEffect } from 'react';

function useScroll({ initial = 0, fn } = {}) {
  const [scroll, setScroll] = useState(initial);
  const elementRef = useRef();


  const handleScroll = () => {
    if (elementRef.current) {
      setScroll(elementRef.current.scrollTop);
      fn && fn();
    }
  };

  useEffect(() => {
    const element = elementRef.current;
    if (element) {
      element.addEventListener('scroll', handleScroll);
      // 组件卸载时移除监听器
      return () => element.removeEventListener('scroll', handleScroll);
    }
  }, []); // 空依赖数组意味着只在组件挂载时添加监听器一次

  return [scroll, elementRef];
}

export default useScroll;
